import { Controller } from "@hotwired/stimulus"

const SMALL_SCREEN_MIN_WIDTH = 640

export default class extends Controller {
  #mql

  connect() {
    this.#mql = window.matchMedia(`(min-width: ${ SMALL_SCREEN_MIN_WIDTH }px)`)

    this.#mql.addEventListener('change', this.#onChange)
    this.#onChange(this.#mql)
  }

  disconnect() {
    this.#mql.removeEventListener('change', this.#onChange)
  }

  #onChange = e => {
    if (e.matches) {
      this.element.removeAttribute('data-mobile-screen')
    } else {
      this.element.setAttribute('data-mobile-screen', '')
    }

    this.dispatch('change')
  }
}
